import { render } from "./BullseyeWhy.vue?vue&type=template&id=1a4c0526"
import script from "./BullseyeWhy.vue?vue&type=script&lang=js"
export * from "./BullseyeWhy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__